import React from "react";
import { HiOutlineBriefcase } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneTourPackage } from "../../../lib/sysNavigation/SysNavigation";

type TourPackageRow = {
  tour_package_id: number | string;
  name?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<TourPackageRow>
    type={_TYPES_.TOURPACKAGE}
    title="Tour Packages"
    subtitle="Guided tour packages featured on the public site."
    icon={<HiOutlineBriefcase className="h-5 w-5" />}
    addRoute="/data/tour/package/add"
    editRoute="/data/tour/package/edit"
    pushOne={pushOneTourPackage}
    dataKey="tourPackages"
    countKey="tourPackagesCount"
    idField="tour_package_id"
    titleField="name"
    searchFields={["name"]}
    simpleCrud
  />
);

export default Overview;
